import React, { Fragment } from 'react'
import styled from 'styled-components'
import Spinner from './Utils/Spinner'
import Error from './Utils/Error'
import { gaEvents } from '../analytics/events'
import { isValidEmail } from '../utils/utils'
import { shouldTranslateTo } from '../utils/utils'
import { useLocation } from 'react-router-dom'
import { withAuth } from './AuthContext'
import { withSearch } from './SearchContext'
import { withRouter } from 'react-router-dom'
import {
  Title,
  CustomSubtitle,
  ContainerFlexColumn,
  Input,
  ActionButtons,
} from './Utils/CustomClasses'

const Header = styled.div`
  background-color: #f6f0e6;
  padding: 70px 50px 10px;

  background-image: url(${(props) => props.image});
  background-size: 90%;
  background-repeat: no-repeat;
  background-position: center top;

  @media screen and (max-width: 768px) {
    background-size: contain;
  }
`

const GiftButton = styled(ActionButtons)`
  margin-top: 30px;
  ${(props) => props.fullWidth && `width: -webkit-fill-available`};
  justify-content: center;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available;
    padding: 15px 10px;
  }
`

const FormWrapper = styled.div`
  width: -webkit-fill-available;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 8vh 10% 4vh;
  text-align: center;

  @media screen and (max-width: 768px) {
    padding: 8vh 5% 4vh;
  }
`

const Form = styled.form`
  text-align: left;
  width: 40vw;
  min-width: 400px;

  @media screen and (max-width: 768px) {
    width: -webkit-fill-available !important;
    min-width: unset !important;
  }
`

const SignupMailingListActivate = (props) => {
  const [user, setUser] = React.useState(null)
  const [email, setEmail] = React.useState('')
  const [password, setPassword] = React.useState('')
  const [passwordConfirmation, setPasswordConfirmation] = React.useState('')
  const [activationCode, setActivationCode] = React.useState('')
  const [emailError, setEmailError] = React.useState(false)
  const [activationCodeError, setActivationCodeError] = React.useState(false)
  const [passwordError, setPasswordError] = React.useState(false)
  const [error, setError] = React.useState(false)
  const [errorText, setErrorText] = React.useState('')
  const [loading, setLoading] = React.useState(false)
  const [showEmail, setShowEmail] = React.useState(true)
  const [showEmailSent, setShowEmailSent] = React.useState(false)
  const [showPassword, setShowPassword] = React.useState(false)
  const [pageText, setPageText] = React.useState([])
  const location = useLocation()
  const queryParameters = new URLSearchParams(location.search)

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue, setPageState) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageState(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }
    getPageText('welcome-mailing-list-signup', language, setPageText)

    setShowEmail(!location.pathname.includes('code'))
    if (location.pathname.includes('code')) {
      setActivationCode(queryParameters.get('id'))
      const data = {
        code: queryParameters.get('id'),
      }
      axios
        .post('/api/ml-code/verify', data)
        .then((response) => {
          if (response.data.user) {
            setUser(response.data.user)
            setShowPassword(true)
          } else {
            setActivationCodeError(true)
            setShowEmailSent(true)
          }
        })
        .catch((err) => {
          setError(true)
          setErrorText(err)
        })
        .finally(() => {
          setLoading(false)
        })
    }
  }, [])

  const updateEmail = (e) => {
    setEmailError(false)
    setError(false)
    setEmail(e)
  }

  const updatePassword = (e) => {
    setPasswordError(false)
    setError(false)
    setPassword(e)
  }

  const updatePasswordConfirmation = (e) => {
    setPasswordError(false)
    setError(false)
    setPasswordConfirmation(e)
  }

  const HandleMembershipActivation = (e) => {
    e.preventDefault()
    if (showEmailSent) {
      setEmail('')
      setShowEmail(true)
      setShowEmailSent(false)
      setActivationCodeError(false)
      return
    } else {
      if (showPassword) {
        if (!password) {
          setError(true)
          setPasswordError(true)
          setErrorText(pageText[17])
          return
        } else if (password !== passwordConfirmation) {
          setError(true)
          setPasswordError(true)
          setErrorText(pageText[12])
          return
        }

        setLoading(true)

        const data = {
          user: user,
          password: password,
          password_confirmation: password,
        }

        const auth = props.auth

        axios
          .post('/api/ml-code/add-pw', data)
          .then((response) => {
            gaEvents.mailingListSignupStage2(response.data.id)
            auth.handleLogin(response.data)
            window.open('/dashboard', '_self')
          })
          .catch((err) => {
            setError(true)
            setErrorText(err)
          })
          .finally(() => {
            setLoading(false)
          })
      } else {
        if (!isValidEmail(email)) {
          setError(true)
          setEmailError(true)
          setErrorText(pageText[11])
          return
        }

        setLoading(true)

        const data = {
          email: email,
        }

        axios
          .post('/api/ml-code/send-email', data)
          .then((response) => {
            setShowEmail(false)
            setShowEmailSent(true)
          })
          .catch((err) => {
            setError(true)
            setErrorText(err)
          })
          .finally(() => {
            setLoading(false)
          })
      }
    }
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <div>
      {loading && <Spinner />}
      <Header>
        <Title
          center
          smCenter
          size="2.5rem"
          sizemd="25px"
          sizesm="22px"
          margin="0 0 40px 0"
          paddingSm="0 18px"
          dangerouslySetInnerHTML={{
            __html: `${pageText[0]}`,
          }}
        />
        <CustomSubtitle
          center
          smCenter
          size="1.4rem"
          sizemd="25px"
          sizesm="22px"
          margin="0 0 40px 0"
          paddingSm="0 18px"
          dangerouslySetInnerHTML={{ __html: `${pageText[1]}` }}
        />
      </Header>
      <ContainerFlexColumn
        background="#FFFBF4"
        center
        gap="50px"
        gapMd="30px"
        padding="0 80px 68px 80px"
        paddingSm="0 20px 68px 20px"
      >
        <FormWrapper id="form">
          <CustomSubtitle
            center
            size="22px"
            sizemd="22px"
            sizesm="17px"
            margin="0 0 40px 0px"
            dangerouslySetInnerHTML={{
              __html: `${
                showEmail
                  ? pageText[2]
                  : activationCodeError
                  ? pageText[16]
                  : showEmailSent
                  ? pageText[13]
                  : pageText[15]
              }`,
            }}
          />
          {/*showPassword ? (
                        <Title
                            center
                            smCenter
                            size="30px"
                            sizemd="25px"
                            sizesm="22px"
                            margin="0 0 40px 0"
                            paddingSm="0 18px"
                            dangerouslySetInnerHTML={{
                                __html: `${pageText[10] + activationCode}`,
                            }}
                        />
                        ) : null*/}
          <Form>
            {showEmail ? (
              <Fragment>
                {/* Email */}
                <CustomSubtitle
                  bold
                  size="18px"
                  margin="0 0 11px 0px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[3]}`,
                  }}
                />
                <Input
                  id="email"
                  type="email"
                  name="email"
                  className={emailError && 'error-border'}
                  placeholder={pageText[4]}
                  required
                  autoFocus
                  value={email}
                  onChange={(e) => updateEmail(e.target.value)}
                />
              </Fragment>
            ) : null}
            {showPassword ? (
              <Fragment>
                {/* Password */}
                <CustomSubtitle
                  bold
                  size="18px"
                  margin="0 0 11px 0px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[5]}`,
                  }}
                />
                <Input
                  id="password"
                  type="password"
                  name="password"
                  className={passwordError && 'error-border'}
                  placeholder={pageText[6]}
                  required
                  autoFocus
                  value={password}
                  onChange={(e) => updatePassword(e.target.value)}
                />
                {/* Confirm Password */}
                <CustomSubtitle
                  bold
                  size="18px"
                  margin="0 0 11px 0px"
                  dangerouslySetInnerHTML={{
                    __html: `${pageText[7]}`,
                  }}
                />
                <Input
                  id="passwordConfirmation"
                  type="password"
                  name="passwordConfirmation"
                  className={passwordError && 'error-border'}
                  placeholder={pageText[8]}
                  required
                  autoFocus
                  value={passwordConfirmation}
                  onChange={(e) => updatePasswordConfirmation(e.target.value)}
                />
              </Fragment>
            ) : null}
            <Fragment>
              {error && <Error error={errorText} />}

              <GiftButton
                fullWidth
                padding="12px 14px"
                type="submit"
                onClick={(e) => HandleMembershipActivation(e)}
              >
                {showEmailSent ? pageText[14] : pageText[9]}
              </GiftButton>
            </Fragment>
          </Form>
        </FormWrapper>
      </ContainerFlexColumn>
    </div>
  )
}

export default withRouter(withSearch(withAuth(SignupMailingListActivate)))
